import { css, SerializedStyles } from '@emotion/core';
import { variables as vars, media, aTag } from '@domain-group/fe-brary';

// eslint-disable-next-line import/prefer-default-export
export const wrapper = css`
  padding: 10px 0 10px;
  width: 100%;
  font-size: ${vars.font.smallFontSize};
  display: block;

  span:last-of-type {
    color: ${vars.colour.neutral600};
    cursor: default;
  }

  ${media('>=desktop')} {
    font-size: ${vars.font.baseFontSize};
  }
`;

const fullWidth = css`
  max-width: none;
  padding: 0 10px;
`;

export const innerWrapper = (isFullWidth = false): SerializedStyles => css`
  max-width: 90%;
  margin: auto;
  padding-left: 5px;

  ${isFullWidth && fullWidth}

  &::before {
    content: '';
    margin: 0 auto;
  }

  > li:first-of-type > a:first-of-type {
    padding-left: 0;

    &::before {
      content: none;
    }
  }

  ${media('>=desktop')} {
    max-width: 1300px;
  }
`;

export const crumb = css`
  display: inline-block;
  vertical-align: middle;
`;

export const link = css`
  ${aTag}
  display: inline-block;
  color: ${vars.colour.neutral600};
  padding: 8px 0 9px 8px;

  &:hover,
  &:focus,
  &:active {
    color: ${vars.colour.secondary};
    text-decoration: none;
  }
`;

export const chevron = css`
  margin-right: 5px;
  color: ${vars.colour.neutral600};
  width: 10px;
  height: 10px;
`;

export const homeIcon = css`
  vertical-align: middle;
  stroke-width: 1.5;
`;
